// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.session-training-summary {
  margin: 0 0 18px;
  padding: 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
}

.session-training-summary--tappable {
  display: block;
  width: 100%;
  margin: 0 0 18px;
  padding: 16px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(12px);
  color: inherit;
  font: inherit;
  text-align: left;
  cursor: pointer;
  transition: transform 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}

.session-training-summary--tappable:hover:not(:disabled) {
  border-color: rgba(8, 119, 188, 0.35);
  background: rgba(8, 119, 188, 0.08);
}

.session-training-summary--tappable:active:not(:disabled) {
  transform: scale(0.99);
}

.session-training-summary--disabled,
.session-training-summary--tappable:disabled {
  cursor: default;
  opacity: 0.85;
}

.light-mode .session-training-summary--tappable {
  background: rgba(255, 255, 255, 0.72);
  border-color: rgba(0, 0, 0, 0.06);
}

.light-mode .session-training-summary--tappable:hover:not(:disabled) {
  background: rgba(8, 119, 188, 0.06);
  border-color: rgba(8, 119, 188, 0.2);
}

.light-mode .session-training-summary {
  background: rgba(255, 255, 255, 0.72);
  border-color: rgba(0, 0, 0, 0.06);
}

.session-training-summary__header {
  display: flex;
  gap: 12px;
  align-items: flex-start;
  margin-bottom: 14px;
}

.session-training-summary__header-text {
  flex: 1 1;
  min-width: 0;
}

.session-training-summary__chevron {
  flex-shrink: 0;
  margin-top: 6px;
  opacity: 0.55;
}

.session-training-summary__header-icon {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(8, 119, 188, 0.16);
  color: #0877bc;
  flex-shrink: 0;
}

.session-training-summary__title {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: inherit;
}

.session-training-summary__footnote {
  margin: 4px 0 0;
  font-size: 0.78rem;
  opacity: 0.72;
}

.session-training-summary__loading {
  display: flex;
  justify-content: center;
  padding: 24px 0;
}

.session-training-summary__metrics-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.session-training-summary__metric {
  padding: 12px;
  border-radius: 12px;
  background: rgba(0, 0, 0, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.06);
}

.light-mode .session-training-summary__metric {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(0, 0, 0, 0.05);
}

/* Per-metric tinted tiles — aligned with PlayerSessionResultsDialog HR subcards / iOS metric cards */
.session-training-summary__metric--duration {
  background: rgba(100, 210, 255, 0.08);
  border-color: rgba(100, 210, 255, 0.16);
}

.session-training-summary__metric--max {
  background: rgba(255, 69, 58, 0.08);
  border-color: rgba(255, 69, 58, 0.16);
}

.session-training-summary__metric--max_intensity {
  background: rgba(175, 82, 222, 0.08);
  border-color: rgba(175, 82, 222, 0.16);
}

.session-training-summary__metric--avg {
  background: rgba(52, 199, 89, 0.08);
  border-color: rgba(52, 199, 89, 0.16);
}

.session-training-summary__metric--avg_intensity {
  background: rgba(8, 119, 188, 0.08);
  border-color: rgba(8, 119, 188, 0.16);
}

.session-training-summary__metric--calories {
  background: rgba(255, 149, 0, 0.08);
  border-color: rgba(255, 149, 0, 0.16);
}

.light-mode .session-training-summary__metric--duration {
  background: rgba(100, 210, 255, 0.08);
  border-color: rgba(100, 210, 255, 0.16);
}

.light-mode .session-training-summary__metric--max {
  background: rgba(255, 69, 58, 0.08);
  border-color: rgba(255, 69, 58, 0.16);
}

.light-mode .session-training-summary__metric--max_intensity {
  background: rgba(175, 82, 222, 0.08);
  border-color: rgba(175, 82, 222, 0.16);
}

.light-mode .session-training-summary__metric--avg {
  background: rgba(52, 199, 89, 0.08);
  border-color: rgba(52, 199, 89, 0.16);
}

.light-mode .session-training-summary__metric--avg_intensity {
  background: rgba(8, 119, 188, 0.08);
  border-color: rgba(8, 119, 188, 0.16);
}

.light-mode .session-training-summary__metric--calories {
  background: rgba(255, 149, 0, 0.08);
  border-color: rgba(255, 149, 0, 0.16);
}

.session-training-summary__metric--dimmed {
  opacity: 0.55;
}

.session-training-summary__metric-label-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.session-training-summary__metric-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.light-mode .session-training-summary__metric-icon {
  background: rgba(0, 0, 0, 0.04);
}

.session-training-summary__metric--duration .session-training-summary__metric-icon {
  background: rgba(100, 210, 255, 0.14);
}

.session-training-summary__metric--max .session-training-summary__metric-icon {
  background: rgba(255, 69, 58, 0.14);
}

.session-training-summary__metric--max_intensity .session-training-summary__metric-icon {
  background: rgba(175, 82, 222, 0.14);
}

.session-training-summary__metric--avg .session-training-summary__metric-icon {
  background: rgba(52, 199, 89, 0.14);
}

.session-training-summary__metric--avg_intensity .session-training-summary__metric-icon {
  background: rgba(8, 119, 188, 0.14);
}

.session-training-summary__metric--calories .session-training-summary__metric-icon {
  background: rgba(255, 149, 0, 0.14);
}

.session-training-summary__metric-label {
  display: block;
  font-size: 0.72rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  opacity: 0.7;
  min-width: 0;
}

.session-training-summary__metric-value-row {
  display: flex;
  align-items: baseline;
  gap: 4px;
  min-width: 0;
}

.session-training-summary__metric-value {
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1.1;
  min-width: 0;
}

.session-training-summary__metric--duration .session-training-summary__metric-value {
  font-size: 1.2rem;
}

.session-training-summary__metric-unit {
  font-size: 0.78rem;
  opacity: 0.75;
}

.duration-metric-value {
  display: inline-flex;
  align-items: baseline;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 0.2em;
  max-width: 100%;
}

.duration-metric-value__part {
  display: inline-flex;
  align-items: baseline;
}

.duration-metric-value__num {
  font-size: inherit;
  font-weight: inherit;
  letter-spacing: -0.02em;
}

.duration-metric-value__unit {
  font-size: 0.52em;
  font-weight: 700;
  opacity: 0.72;
  margin-left: 0.08em;
  line-height: 1;
}

.session-training-summary__metric-subtitle {
  display: block;
  margin-top: 4px;
  font-size: 0.72rem;
  opacity: 0.68;
}

.session-training-summary__chart-card {
  margin-top: 14px;
  padding: 12px;
  border-radius: 14px;
  background: #0d1117;
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.light-mode .session-training-summary__chart-card {
  background: #101820;
}

.session-training-summary__chart-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  color: #fff;
}

.session-training-summary__empty-chart {
  margin-top: 12px;
  padding: 14px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  opacity: 0.75;
  background: rgba(0, 0, 0, 0.12);
}

.light-mode .session-training-summary__empty-chart {
  background: rgba(0, 0, 0, 0.04);
}

.session-training-summary__toast {
  position: fixed;
  left: 50%;
  bottom: max(24px, env(safe-area-inset-bottom, 0px));
  transform: translateX(-50%);
  z-index: 10050;
  max-width: min(92vw, 360px);
  padding: 12px 16px;
  border-radius: 12px;
  background: rgba(20, 24, 32, 0.92);
  color: #fff;
  font-size: 0.85rem;
  line-height: 1.35;
  text-align: center;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);
  pointer-events: none;
}

.light-mode .session-training-summary__toast {
  background: rgba(30, 30, 30, 0.9);
}

.session-training-summary__rankings {
  display: grid;
  gap: 14px;
}

.session-training-summary__ranking-block {
  padding: 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
}

.light-mode .session-training-summary__ranking-block {
  background: rgba(8, 119, 188, 0.04);
  border-color: rgba(8, 119, 188, 0.12);
}

.session-training-summary__ranking-title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 600;
}

.session-training-summary__ranking-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 6px;
}

.session-training-summary__ranking-row {
  display: grid;
  grid-template-columns: 24px 1fr auto;
  gap: 8px;
  align-items: center;
  font-size: 13px;
}

.session-training-summary__ranking-pos {
  font-weight: 700;
  color: var(--brand-primary, #0877bc);
}

.session-training-summary__ranking-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.session-training-summary__ranking-value {
  font-weight: 600;
}

.session-training-summary__ranking-unit {
  margin-left: 2px;
  font-size: 11px;
  font-weight: 500;
  opacity: 0.75;
}

@media (min-width: 900px) {
  .session-training-summary,
  .session-training-summary--tappable {
    padding: 14px;
    margin-bottom: 0;
  }

  .session-training-summary__header {
    margin-bottom: 10px;
    gap: 10px;
  }

  .session-training-summary__title {
    font-size: 0.92rem;
  }

  .session-training-summary__footnote {
    font-size: 0.72rem;
  }

  .session-training-summary__metrics-grid {
    gap: 8px;
  }

  .session-training-summary__metric {
    padding: 10px;
  }

  .session-training-summary__metric-value {
    font-size: 1.2rem;
  }

  .session-training-summary__rankings {
    gap: 10px;
  }

  .session-training-summary__ranking-block {
    padding: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SessionTrainingSummary.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,2BAA2B;EAC3B,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gFAAgF;AAClF;;AAEA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA,qGAAqG;AACrG;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,SAAS;EACT,mDAAmD;EACnD,2BAA2B;EAC3B,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE;;IAEE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".session-training-summary {\n  margin: 0 0 18px;\n  padding: 16px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n}\n\n.session-training-summary--tappable {\n  display: block;\n  width: 100%;\n  margin: 0 0 18px;\n  padding: 16px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  backdrop-filter: blur(12px);\n  color: inherit;\n  font: inherit;\n  text-align: left;\n  cursor: pointer;\n  transition: transform 0.15s ease, border-color 0.15s ease, background 0.15s ease;\n}\n\n.session-training-summary--tappable:hover:not(:disabled) {\n  border-color: rgba(8, 119, 188, 0.35);\n  background: rgba(8, 119, 188, 0.08);\n}\n\n.session-training-summary--tappable:active:not(:disabled) {\n  transform: scale(0.99);\n}\n\n.session-training-summary--disabled,\n.session-training-summary--tappable:disabled {\n  cursor: default;\n  opacity: 0.85;\n}\n\n.light-mode .session-training-summary--tappable {\n  background: rgba(255, 255, 255, 0.72);\n  border-color: rgba(0, 0, 0, 0.06);\n}\n\n.light-mode .session-training-summary--tappable:hover:not(:disabled) {\n  background: rgba(8, 119, 188, 0.06);\n  border-color: rgba(8, 119, 188, 0.2);\n}\n\n.light-mode .session-training-summary {\n  background: rgba(255, 255, 255, 0.72);\n  border-color: rgba(0, 0, 0, 0.06);\n}\n\n.session-training-summary__header {\n  display: flex;\n  gap: 12px;\n  align-items: flex-start;\n  margin-bottom: 14px;\n}\n\n.session-training-summary__header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.session-training-summary__chevron {\n  flex-shrink: 0;\n  margin-top: 6px;\n  opacity: 0.55;\n}\n\n.session-training-summary__header-icon {\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(8, 119, 188, 0.16);\n  color: #0877bc;\n  flex-shrink: 0;\n}\n\n.session-training-summary__title {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: inherit;\n}\n\n.session-training-summary__footnote {\n  margin: 4px 0 0;\n  font-size: 0.78rem;\n  opacity: 0.72;\n}\n\n.session-training-summary__loading {\n  display: flex;\n  justify-content: center;\n  padding: 24px 0;\n}\n\n.session-training-summary__metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 10px;\n}\n\n.session-training-summary__metric {\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(0, 0, 0, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.light-mode .session-training-summary__metric {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: rgba(0, 0, 0, 0.05);\n}\n\n/* Per-metric tinted tiles — aligned with PlayerSessionResultsDialog HR subcards / iOS metric cards */\n.session-training-summary__metric--duration {\n  background: rgba(100, 210, 255, 0.08);\n  border-color: rgba(100, 210, 255, 0.16);\n}\n\n.session-training-summary__metric--max {\n  background: rgba(255, 69, 58, 0.08);\n  border-color: rgba(255, 69, 58, 0.16);\n}\n\n.session-training-summary__metric--max_intensity {\n  background: rgba(175, 82, 222, 0.08);\n  border-color: rgba(175, 82, 222, 0.16);\n}\n\n.session-training-summary__metric--avg {\n  background: rgba(52, 199, 89, 0.08);\n  border-color: rgba(52, 199, 89, 0.16);\n}\n\n.session-training-summary__metric--avg_intensity {\n  background: rgba(8, 119, 188, 0.08);\n  border-color: rgba(8, 119, 188, 0.16);\n}\n\n.session-training-summary__metric--calories {\n  background: rgba(255, 149, 0, 0.08);\n  border-color: rgba(255, 149, 0, 0.16);\n}\n\n.light-mode .session-training-summary__metric--duration {\n  background: rgba(100, 210, 255, 0.08);\n  border-color: rgba(100, 210, 255, 0.16);\n}\n\n.light-mode .session-training-summary__metric--max {\n  background: rgba(255, 69, 58, 0.08);\n  border-color: rgba(255, 69, 58, 0.16);\n}\n\n.light-mode .session-training-summary__metric--max_intensity {\n  background: rgba(175, 82, 222, 0.08);\n  border-color: rgba(175, 82, 222, 0.16);\n}\n\n.light-mode .session-training-summary__metric--avg {\n  background: rgba(52, 199, 89, 0.08);\n  border-color: rgba(52, 199, 89, 0.16);\n}\n\n.light-mode .session-training-summary__metric--avg_intensity {\n  background: rgba(8, 119, 188, 0.08);\n  border-color: rgba(8, 119, 188, 0.16);\n}\n\n.light-mode .session-training-summary__metric--calories {\n  background: rgba(255, 149, 0, 0.08);\n  border-color: rgba(255, 149, 0, 0.16);\n}\n\n.session-training-summary__metric--dimmed {\n  opacity: 0.55;\n}\n\n.session-training-summary__metric-label-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 6px;\n}\n\n.session-training-summary__metric-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  border-radius: 7px;\n  background: rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.light-mode .session-training-summary__metric-icon {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.session-training-summary__metric--duration .session-training-summary__metric-icon {\n  background: rgba(100, 210, 255, 0.14);\n}\n\n.session-training-summary__metric--max .session-training-summary__metric-icon {\n  background: rgba(255, 69, 58, 0.14);\n}\n\n.session-training-summary__metric--max_intensity .session-training-summary__metric-icon {\n  background: rgba(175, 82, 222, 0.14);\n}\n\n.session-training-summary__metric--avg .session-training-summary__metric-icon {\n  background: rgba(52, 199, 89, 0.14);\n}\n\n.session-training-summary__metric--avg_intensity .session-training-summary__metric-icon {\n  background: rgba(8, 119, 188, 0.14);\n}\n\n.session-training-summary__metric--calories .session-training-summary__metric-icon {\n  background: rgba(255, 149, 0, 0.14);\n}\n\n.session-training-summary__metric-label {\n  display: block;\n  font-size: 0.72rem;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  opacity: 0.7;\n  min-width: 0;\n}\n\n.session-training-summary__metric-value-row {\n  display: flex;\n  align-items: baseline;\n  gap: 4px;\n  min-width: 0;\n}\n\n.session-training-summary__metric-value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  line-height: 1.1;\n  min-width: 0;\n}\n\n.session-training-summary__metric--duration .session-training-summary__metric-value {\n  font-size: 1.2rem;\n}\n\n.session-training-summary__metric-unit {\n  font-size: 0.78rem;\n  opacity: 0.75;\n}\n\n.duration-metric-value {\n  display: inline-flex;\n  align-items: baseline;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  gap: 0.2em;\n  max-width: 100%;\n}\n\n.duration-metric-value__part {\n  display: inline-flex;\n  align-items: baseline;\n}\n\n.duration-metric-value__num {\n  font-size: inherit;\n  font-weight: inherit;\n  letter-spacing: -0.02em;\n}\n\n.duration-metric-value__unit {\n  font-size: 0.52em;\n  font-weight: 700;\n  opacity: 0.72;\n  margin-left: 0.08em;\n  line-height: 1;\n}\n\n.session-training-summary__metric-subtitle {\n  display: block;\n  margin-top: 4px;\n  font-size: 0.72rem;\n  opacity: 0.68;\n}\n\n.session-training-summary__chart-card {\n  margin-top: 14px;\n  padding: 12px;\n  border-radius: 14px;\n  background: #0d1117;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.light-mode .session-training-summary__chart-card {\n  background: #101820;\n}\n\n.session-training-summary__chart-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 8px;\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: #fff;\n}\n\n.session-training-summary__empty-chart {\n  margin-top: 12px;\n  padding: 14px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  opacity: 0.75;\n  background: rgba(0, 0, 0, 0.12);\n}\n\n.light-mode .session-training-summary__empty-chart {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.session-training-summary__toast {\n  position: fixed;\n  left: 50%;\n  bottom: max(24px, env(safe-area-inset-bottom, 0px));\n  transform: translateX(-50%);\n  z-index: 10050;\n  max-width: min(92vw, 360px);\n  padding: 12px 16px;\n  border-radius: 12px;\n  background: rgba(20, 24, 32, 0.92);\n  color: #fff;\n  font-size: 0.85rem;\n  line-height: 1.35;\n  text-align: center;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.28);\n  pointer-events: none;\n}\n\n.light-mode .session-training-summary__toast {\n  background: rgba(30, 30, 30, 0.9);\n}\n\n.session-training-summary__rankings {\n  display: grid;\n  gap: 14px;\n}\n\n.session-training-summary__ranking-block {\n  padding: 12px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.light-mode .session-training-summary__ranking-block {\n  background: rgba(8, 119, 188, 0.04);\n  border-color: rgba(8, 119, 188, 0.12);\n}\n\n.session-training-summary__ranking-title {\n  margin: 0 0 8px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.session-training-summary__ranking-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: grid;\n  gap: 6px;\n}\n\n.session-training-summary__ranking-row {\n  display: grid;\n  grid-template-columns: 24px 1fr auto;\n  gap: 8px;\n  align-items: center;\n  font-size: 13px;\n}\n\n.session-training-summary__ranking-pos {\n  font-weight: 700;\n  color: var(--brand-primary, #0877bc);\n}\n\n.session-training-summary__ranking-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.session-training-summary__ranking-value {\n  font-weight: 600;\n}\n\n.session-training-summary__ranking-unit {\n  margin-left: 2px;\n  font-size: 11px;\n  font-weight: 500;\n  opacity: 0.75;\n}\n\n@media (min-width: 900px) {\n  .session-training-summary,\n  .session-training-summary--tappable {\n    padding: 14px;\n    margin-bottom: 0;\n  }\n\n  .session-training-summary__header {\n    margin-bottom: 10px;\n    gap: 10px;\n  }\n\n  .session-training-summary__title {\n    font-size: 0.92rem;\n  }\n\n  .session-training-summary__footnote {\n    font-size: 0.72rem;\n  }\n\n  .session-training-summary__metrics-grid {\n    gap: 8px;\n  }\n\n  .session-training-summary__metric {\n    padding: 10px;\n  }\n\n  .session-training-summary__metric-value {\n    font-size: 1.2rem;\n  }\n\n  .session-training-summary__rankings {\n    gap: 10px;\n  }\n\n  .session-training-summary__ranking-block {\n    padding: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
